"use client";
import { useState } from "react";
import { useSearchParams } from "next/navigation";
import { Box } from "@mui/material";

import { useStore, observer } from "../../../../service/mobx";
import { ModelIcon } from "../../../../component/Icon/Model";
import { PaperIcon } from "../../../../component/Icon/Papers";
import Tabs from "../../../../component/Tabs";
// import FilterChips from "../../Pane/FilterChips";
import FilterChip from "../../../../component/Chip/Filter";
import Horizontal from "../../../../component/Chip/Horizontal";

function TabsSelector({ publisher, paperID, product, isWhiteLabelled }) {
  const [tabs] = useState(
    [
      product.paper
        ? {
            href: "paper",
            Icon: PaperIcon,
            iconPosition: "start",
            shallow: true,
            label: "Paper"
          }
        : undefined,
      product.models?.length
        ? {
            Icon: ModelIcon,
            href: "model",
            iconPosition: "start",
            shallow: true,
            label: `Model${product.models.length === 1 ? "" : "s"}`
          }
        : undefined
    ].filter(defined => defined)
  );
  const { analytics, device, reader } = useStore();
  const searchParams = useSearchParams();
  const query = searchParams.size === 0 ? "" : "?" + searchParams.toString();

  return device.measured === false ? null : (isWhiteLabelled === false &&
      device.isDesktop === false) ||
    (isWhiteLabelled && device.isPhone) ? (
    <Box
      top={isWhiteLabelled ? 0 : -16}
      zIndex={1}
      position="sticky"
      overflow="hidden"
      mr={{ compact: -2, expanded: 0 }}
      bgcolor="var(--surface-container-lowest)"
    >
      <Horizontal
        chips={[
          ...tabs.map(({ label, href }) => [label, "", "", href]),
          ...reader.relatedContentFiltered
        ].map(([label, , , url]) => (
          <FilterChip
            key={label}
            small
            label={label}
            scroll={false}
            href={`/docs/${publisher}/${paperID}/${
              reader.tab === url ? reader.viewing : url
            }${query}`}
            selected={reader.tab === url}
            onClick={() => {
              analytics.track.event("Related Filter", {
                type: label,
                value: url
              });
            }}
          />
        ))}
      />
    </Box>
  ) : tabs.length < 2 ? null : (
    <Tabs
      noOutline
      tabs={tabs}
      override={reader.viewing === "paper" ? "0" : "1"}
    />
  );
}

export default observer(TabsSelector);
